import { create } from "zustand";
import axios from "../lib/axios.js";

export const useConsultationStore = create((set) => ({
  isLoading: false,
  error: null,

  sendConsultationRequest: async (formData) => {
    set({ isLoading: true, error: null });

    try {
      const response = await axios.post("/send-email", formData);
      return true; // success
    } catch (error) {
      console.error("Consultation error:", error);
      set({
        error:
          error.response?.data?.error || "Failed to send consultation request",
      });
      return false; // failure
    } finally {
      set({ isLoading: false });
    }
  },
}));
